export default __webpack_public_path__ + "b2ee542bcf71c309db7fe3a52dc35508.png";